<div class="tg-autocomplete-container">
  <span class="sr-only" aria-live="polite" aria-atomic="true">{{ srResultsMessage }}</span>
  <p-autoComplete #tgAutoComplete
                  (keydown)="onKeyDown($event)"
                  [(ngModel)]="dummyArray"
                  [suggestions]="options"
                  (completeMethod)="onSearch($event)"
                  (onSelect)="onItemSelect($event)"
                  (onUnselect)="onItemUnselect($event)"
                  (onShow)="onPanelShow()"
                  [dropdown]="true"
                  [multiple]="true"
                  optionLabel="label"
                  [virtualScroll]="true"
                  [virtualScrollItemSize]="38"
                  [lazy]="question?.AjaxLoad"
                  (onLazyLoad)="onLazyLoad($event)"

                  styleClass="tg-structural-autocomplete"
                  panelStyleClass="tg-solid-panel"
                  appendTo="body">

    <ng-template let-opt let-i="index" pTemplate="item">
      <!-- ✅ highlight class driven by component state, not PrimeNG focus -->
      <div class="tg-checkbox-row"
           [class.tg-keyboard-active]="i === highlightedIndex"
           (click)="onOptionClick($event, opt)">
        <input type="checkbox"
               [checked]="isSelected(opt)"
               class="tg-checkbox-input"
               tabindex="-1"
               aria-hidden="true" style="pointer-events: none;">
        <span class="tg-checkbox-label">{{ opt.label }}</span>
        <span class="sr-only">{{ isSelected(opt) ? 'Selected' : 'Unselected' }}</span>
      </div>
    </ng-template>

  </p-autoComplete>

  <ul class="selectionList bvbv" *ngIf="selected && selected.length > 0" aria-live="polite">
    <li class="selection lightAccentBkg" *ngFor="let item of selected">
      {{ item.label }}
      <button type="button" class="closeButton remove" tabindex="0" (click)="removeTag($event, item)">
        <span class="screenReaderText">Remove selection {{item.label}}</span>
      </button>
    </li>
  </ul>

  <div class="tg-loading-status" *ngIf="loading" role="status" aria-label="Loading options" aria-live="polite">
    <i class="pi pi-spinner pi-spin" aria-hidden="true"></i>
  </div>
</div>
